<template>
  <Modal
    :is-closable="true"
    header-class="client-selection-modal-header"
    container-class="atb-px-0 atb-w-76"
    @on-modal-close="emit('cancelSelection')"
  >
    <template #header>
      {{ $t('clientSelection') }}
    </template>
    <template #body>
      <div id="client-select-description">
        {{ $t('clientSelectionDescription') }}
      </div>
      <div id="client-selection-section">
        <!--
          // TODO: Create an interface for this attribute or use an existing one
           -->
        <Dropdown
          v-model="selectedClientName"
          :items="clientStore.clientList"
          :label="$t('clientList')"
          filterable
          field-label-class="option-class"
          active-item-class="d-active"
          :get-option-label="(e: any) => e.clientName"
          :get-option-value="(e: any) => e.clientName"
          @update:modelValue="clientSelectedHandler"
          title="selectedClientName"
        />
      </div>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import Modal from '@atb-ui/eds-vue/src/components/Modal.vue';
  import Dropdown from '@atb-ui/eds-vue/src/components/Dropdown.vue';
  import { useClientStore } from '@/app/features/ams/client/client-store';
  import { useSearchStore } from '@/app/features/ams/common/search-store';

  interface ClientSelectionEvents {
    (_event: 'closeClientSelection'): void;
    (_event: 'cancelSelection'): void;
  }
  const emit = defineEmits<ClientSelectionEvents>();

  const searchStore = useSearchStore();
  const clientStore = useClientStore();
  let selectedClientName = ref('');

  const clientSelectedHandler = () => {
    let index = clientStore.clientList.findIndex(
      ({ clientName }) => clientName === selectedClientName.value
    );
    const selectedClient = clientStore.clientList[index];
    clientStore.setSelectedClient(selectedClient);
    const clientId = clientStore.getSelectedClient.id;
    searchStore.fetchUserLoginNamesList(clientId);
    clientStore.fetchAttributeFilterFunctionList(clientId);
    emit('closeClientSelection');
  };
</script>
<style>
  .client-selection-modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 16px 10px;
    border-bottom: 1px solid #dee2e6;
  }

  #client-select-description {
    font-size: 14px;
    font-weight: 500;
    margin: 0 18px;
  }

  #client-selection-section {
    padding: 24px;
    margin: 0 auto;
    width: 73%;
  }

  #client-dropdown-label {
    font-size: 14px;
    font-weight: 500;
    padding-bottom: 5px;
    line-height: 1.4em;
  }

  .option-class {
    text-align: left;
    padding: 10px 16px;
  }

  .d-active {
    background-color: #426da9;
    color: white;
  }
</style>
